export default __webpack_public_path__ + "static/media/objectstorage_openapi.ffee50cd.yaml";